// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__+Z-E2","spin":"Spinner_spin__ZlANk"};